<template>
	<v-btn
		v-bind="$props"
		color="tertiary"
		class="px-10 black--text text-none tertiary-action-button"
		:class="getQaSelectorClass()"
		v-on="$listeners"
	>
		<slot />
	</v-btn>
</template>

<script>
import { VBtn } from 'vuetify/lib'

export default {
	name: 'tertiary-action-button',
	extends: VBtn,
	methods: {
		getQaSelectorClass () {
			const buttonText = this.$slots.default.find(({ text }) => text).text.trim().replace(/\s/g, '-').toLowerCase()
			return `qa-tertiaryactionbutton-${buttonText}`
		}
	}
}
</script>

<style lang="scss">
	// Add hover lift effect to tertiary action buttons
	.v-btn.tertiary-action-button {
		transition: all 0.3s ease;

		&:hover:not(:disabled) {
			transform: translateY(-2px);
			box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
		}
	}
</style>
